import * as React from 'react'
import Switch, {SwitchProps} from '@mui/material/Switch'
import styled from 'styled-components'
import switchStyles from './switch.styles'

interface ApSwitchProps extends SwitchProps {
  atom_type?: 'primary' | 'secondary'
}

const atomName = {atom_name: 'buttonAtom'}

const label = {inputProps: {'aria-label': 'controlled'}}

const SwitchAtom = styled((props: ApSwitchProps) => (
  <Switch {...atomName} {...props} {...label} />
))`
  ${switchStyles}
`

export default SwitchAtom
